import { buildWhatsAppUrl, DEFAULT_WHATSAPP_MESSAGE } from "@/lib/whatsapp";

export default function WhatsAppFloat() {
  const href = buildWhatsAppUrl(DEFAULT_WHATSAPP_MESSAGE);
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float"
      aria-label="Chat on WhatsApp"
      className="group fixed bottom-5 right-5 z-40 inline-flex items-center justify-center h-14 w-14 rounded-full bg-[#25D366] text-white shadow-[0_18px_40px_rgba(37,211,102,0.4)] hover:bg-[#1ea855] transition-colors wa-pulse"
    >
      <svg
        viewBox="0 0 32 32"
        className="h-7 w-7 fill-white"
        aria-hidden
      >
        <path d="M16.004 3C8.822 3 3 8.822 3 16.004c0 2.283.6 4.494 1.74 6.442L3 29l6.72-1.762a13.02 13.02 0 0 0 6.284 1.6h.005C23.191 28.838 29 23.016 29 15.834 29 12.36 27.65 9.09 25.2 6.633 22.75 4.18 19.48 3 16.004 3zm0 23.667h-.004a10.81 10.81 0 0 1-5.507-1.51l-.395-.235-3.99 1.047 1.065-3.887-.257-.4a10.83 10.83 0 0 1-1.66-5.78c0-5.984 4.87-10.854 10.853-10.854 2.9 0 5.622 1.13 7.673 3.18a10.79 10.79 0 0 1 3.18 7.678c0 5.983-4.874 10.76-10.958 10.76zm5.94-8.07c-.325-.163-1.925-.95-2.224-1.059-.298-.109-.516-.163-.734.163-.217.325-.842 1.06-1.033 1.277-.19.217-.38.244-.706.081-.326-.163-1.375-.507-2.62-1.618-.968-.863-1.622-1.93-1.813-2.256-.19-.326-.02-.502.143-.664.147-.146.326-.38.489-.57.163-.19.217-.326.326-.543.109-.217.054-.407-.027-.57-.082-.164-.734-1.77-1.006-2.42-.265-.635-.535-.55-.734-.559l-.626-.011a1.202 1.202 0 0 0-.87.407c-.298.326-1.14 1.114-1.14 2.716 0 1.602 1.166 3.15 1.328 3.367.163.217 2.297 3.508 5.567 4.919.778.335 1.385.535 1.858.685.78.248 1.49.213 2.052.13.626-.093 1.925-.786 2.197-1.545.272-.76.272-1.41.19-1.545-.081-.135-.298-.217-.624-.38z"/>
      </svg>
    </a>
  );
}
